import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=242433aa"
import script from "./FormTemplate.vue?vue&type=script&lang=js"
export * from "./FormTemplate.vue?vue&type=script&lang=js"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=242433aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports